import React, { Component } from 'react';
import cx from 'classnames';
import { } from 'prop-types';

const CLASS_ROOT = 'table';

const propTypes = {};

class Table extends Component {
  constructor(props) {
    super(props);
    this.getHeader = this.getHeader.bind(this);
    this.getRows = this.getRows.bind(this);
  }

  getHeader(cols) {
    const columns = cols.map((colName, colIndex) => {
      return <th key={colIndex}>{colName}</th>;
    });
    return <tr>{columns}</tr>;
  }

  getRows(rows, cols) {
    return rows.map((row, rowIndex) => {
      const values = cols.map((colName, colKey) => {
        return (
          <td key={colKey} data-label={colName}>
            {row[colKey] === '' ? <div dangerouslySetInnerHTML={{ __html: '&nbsp; -' }} /> : row[colKey]}
          </td>
        );
      });
      return <tr key={rowIndex}>{values}</tr>;
    });
  }

  render() {
    const { children, className, cols, rows, ...other } = this.props;

    const classes = cx(CLASS_ROOT, className);

    return (
      <div className="table-wrapper">
        <table className={classes} {...other}>
          <thead>{this.getHeader(cols)}</thead>
          <tbody>{this.getRows(rows, cols)}</tbody>
        </table>
      </div>
    );
  }
}

Table.propTypes = propTypes;

export default Table;
